import React, { FC } from 'react';
import MuiModal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import { ModalType } from './types';

const Modal: FC<ModalType> = ({
  children,
  open,
  backdropProps,
  ...restProps
}) => {
  return (
    <MuiModal
      open={open}
      BackdropComponent={Backdrop}
      BackdropProps={{...backdropProps}}
      closeAfterTransition
      {...restProps}
    >
      <Fade in={open}>
        {children}
      </Fade>
    </MuiModal>
  );
};

export default Modal;
